import React from "react";
import {
  Link,
  Route,
  Switch,
  BrowserRouter as Router,
  withRouter,
} from "react-router-dom";
import IdManager from "./idcheck_manager/id_manager";
import PushupManager from "./measurement_manager/pushup_manager";
import HealthManager from "./health_manager/health_manager";
import SitupManager from "./measurement_manager/situp_manager";
import DataSender from "../lib/ManagerDataSender";

class Main_Manager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: this.props.location?.state ? this.props.location?.state.name : "",
    };
    this.ds = new DataSender();
  }

  componentDidMount() {
    this.ds
      .checkPermission()
      .then((x) => x.json())
      .then((x) => {
        if (x.permission !== "A") throw new Error();
      })
      .catch((x) => {
        window.location.pathname = "/";
      });
  }

  logout() {
    this.ds.logout().then(() => {
      window.location.pathname = "/";
    });
  }

  render() {
    return (
      <section>
        <Router>
          <div className="manager_main">
            <div>
              <nav>
                <ul>
                  <li>
                    <Link to={"/Manager/SitupManager"}>
                      <div></div>
                      <span>윗몸일으키기</span>
                    </Link>
                  </li>
                  <li>
                    <Link to={"/Manager/PushupManager"}>
                      <div></div>
                      <span>팔굽혀펴기</span>
                    </Link>
                  </li>
                  <li>
                    <Link to={"/Manager/IdManager"}>
                      <div></div>
                      <span>인원 관리</span>
                    </Link>
                  </li>
                  <li>
                    <Link to={"/Manager/HealthManager"}>
                      <div></div>
                      <span>건강 관리</span>
                    </Link>
                  </li>
                  <li onClick={() => this.logout()}>
                    <Link to="#">
                      <div></div>
                      <span>로그아웃</span>
                    </Link>
                  </li>

                  <div className="manager-now">
                    {/* 로그인에서 넘겨준 아이디 값을 표시해야함 */}
                    <b>{this.state.name}님 접속중</b>
                  </div>
                </ul>
              </nav>
            </div>
            <div className="main-manager">
              <Switch>
                <Route exact path={"/Manager"} component={IdManager} />
                <Route path={"/Manager/IdManager"} component={IdManager} />
                <Route
                  path={"/Manager/HealthManager"}
                  component={HealthManager}
                />
                <Route
                  path={"/Manager/PushupManager"}
                  component={PushupManager}
                />
                <Route
                  path={"/Manager/SitupManager"}
                  component={SitupManager}
                />
              </Switch>
            </div>
          </div>
        </Router>
      </section>
    );
  }
}

export default withRouter(Main_Manager);
